import moment from 'moment';

const DateFormat = {
  DEFAULT_DATE_TIME_FORMAT: 'YYYY-MM-DDTHH:mm:ss',
  DEFAULT_DATE_WITH_TIME_FORMAT: 'YYYY-MM-DD-HH-mm-ss',
  DEFAULT_DATE_FORMAT: 'YYYY-MM-DD',
  TEXT_DATE_FORMAT: 'LL',
  DATE_MONTH_YEAR_TIME_SHORT_DISPLAY_FORMAT: 'MMM DD, YYYY - HH:mm',
};

const isToday = (momentDate) => {
  const today = moment();
  return today.isSame(momentDate, 'day');
};

const combineDateAndTimeWithUTCOffset = (momentDate, momentTime, utcOffset) => {
  const dateTime = moment({
    year: momentDate.year(),
    month: momentDate.month(),
    date: momentDate.date(),
    hour: momentTime.hour(),
    minute: momentTime.minute(),
  });
  return dateTime.utcOffset(utcOffset, true);
};

const isServiceStarted = (unixTimestamp = 0) => moment.unix(unixTimestamp).isSameOrBefore();

export {
  DateFormat,
  isToday,
  combineDateAndTimeWithUTCOffset,
  isServiceStarted,
};
